import * as THREE from "three";
import React, { useState, useRef, useMemo, useCallback } from 'react';
import { Canvas,useLoader } from '@react-three/fiber';
//import { OrbitControls, useTexture, Text } from "@react-three/drei";

import Globe from "../../components/space/globeComponent";
import RightGlobe from "../../components/space/rightGlobe";
import LeftGlobe from "../../components/space/leftGlobe";
import VideoGlobe from "../../components/space/videoGlobe";
import Ring from "../../components/space/ring";
import ArtificialSatellite from "../../components/space/artificialSattelite";
import GlobeOne from "../../components/space/globeOne";
import GlobeTwo from "../../components/space/globeTwo";
import GlobeThree from "../../components/space/globeThree";
import GlobeFour from "../../components/space/globeFour";



//import sattelitepng from '../../components/space/assets/img/satellite.jpg';
import globe from '../../components/space/assets/img/Planet.png';
import cdxlogo from '../../assets/images/cdx_explore_logo.png';
import questionMarkIcon from '../../assets/images/icons/question_mark_icon_circle.svg';


import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

//import classes from "./onboarding.module.css";
import "./onboarding.module.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import deanProfileImg from './../../assets/images/Matt_Wittig.jpg';



function Scene() {
    const ref = useRef();
    const points = useMemo(() => [new THREE.Vector3(7, 0, 0), new THREE.Vector3(9, 2, 0), new THREE.Vector3(12, 2, 0)], []);
    const onUpdate = useCallback(self => self.setFromPoints(points), [points]);
    return (
        <>
            <group>
                <line position={[0, 0, 0]} ref={ref}>
                    <bufferGeometry attach="geometry" onUpdate={onUpdate} />
                    <lineBasicMaterial
                        attach="material"
                        color={'#00AEFF'}
                        linewidth={20}
                        linecap={'round'}
                        linejoin={'round'} />
                </line>
                <line position={[0, 0, 0]} ref={ref}>
                    <bufferGeometry attach="geometry" onUpdate={onUpdate} />
                    <lineBasicMaterial
                        attach="material"
                        color={'#00AEFF'}
                        linewidth={20}
                        linecap={'round'}
                        linejoin={'round'} />
                </line>
            </group>
        </>
    );
}

export default function Index() {

    const [cameraPosition, setCameraPosition] = useState([0, 10, 40]);
    const [cameraFov, setCameraFov] = useState(50);
   // const changeCamera = () => { setCameraPosition([0, 10, 40]); }
    const [globeTexture] = useLoader(THREE.TextureLoader, [globe]);
    const [show, setShow] = useState(false);

    return (
        <>
            <Row style={{ textAlign: "left", display: "flex", alignItems: "center" }}>
                <Col style={{ padding: "40px 0 10px 40px" }} sm={10}>
                    <Image src={cdxlogo} style={{ width: "186px", height: "59px" }} />
                </Col>
                <Col>
                    <Image src={questionMarkIcon} />
                    <Image src={questionMarkIcon} style={{ paddingLeft: "18px" }} />
                </Col>
            </Row>
            <Canvas camera={{ position: [0, 1, 15], fov: 75 }}>
                {/* <OrbitControls /> */}
                <ambientLight intensity={0.5} />
                <spotLight position={[0, 0, 0]} angle={90} />
                <ArtificialSatellite position={[0, 0, 0]} />
                <LeftGlobe position={[-7, 0, 0]} />
                <Globe position={[0, 0, 0]} texture={globeTexture} />
                <RightGlobe position={[7, 0, 0]} />
                <VideoGlobe position={[0, 0, 7]} />
                <Ring />
                <GlobeOne position={[-20, -10, 0]} texture={globeTexture} />
                <GlobeTwo position={[-10, -10, 0]} texture={globeTexture} />
                <GlobeThree position={[0, -10, 0]} texture={globeTexture} />
                <GlobeFour position={[10, -10, 0]} texture={globeTexture} />

                <Scene />

            </Canvas>
            <Row >
                <Col sm={10}>
                    <Image src={cdxlogo} style={{ width: "186px", height: "59px" }} />
                </Col>
            </Row>

            <Button variant="primary" onClick={() => setShow(true)}>
        Custom Width Modal
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="mission-director-modal"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Body>
            <div className="mission-director-modal-container">
            <Row className="chiefOfStaff_header_row">
                <Col xs={11} className="custom-col">
                    <div className="chiefOfStaff_Header">
                        <div className="text">Chief Of Staff (Dean)</div>
                        <div className="image"></div>
                    </div>
                </Col>
                <Col xs={1} className="custom-col"></Col>
            </Row>
            <Row  className="chiefOfStaff_profile_row">
                <Col xs={3} className="custom-col">
                    <div className="deanProfileInfo">
                        <span><img src={deanProfileImg}/></span>
                        <span><div>Lorem Ipsum</div><div>DPN Link</div></span>
                    </div>
                </Col>
                <Col xs={9} className="custom-col">
                    <div className="deanProfileIntro">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. <br /><br />Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.
                    </div>
                </Col>
            </Row>
            </div>
        </Modal.Body>
      </Modal>
        </>
    );
}